import { NAMES_ROUTES } from "@/const/routes.constants"
import { useTranslation } from "@/hooks/useTranslation"
import { Form } from "@/organisms/Form"
import {
  useCreateReports,
  usePatchReports
} from "@/pages/ReportsPage/applications/useReports"
import { RecurringReportForm } from "@/pages/ReportsPage/components/organisms/RecurringReportForm"

import type { RecurringReportPageProps } from "."

export const RecurringReportPage = (props: RecurringReportPageProps) => {
  const { Details, Resources } = Form.Section

  const keyPrefix = "reports.form"
  const keySections = `${keyPrefix}.sections`
  const asideItems = [
    { key: Details.sectionId, tKey: `${keySections}.details` },
    { key: Resources.sectionId, tKey: `${keySections}.resources.title` },
    { key: "frequency", tKey: `${keySections}.frequency.title` },
    { key: "share", tKey: `${keySections}.share` }
  ]

  const { ROOT } = NAMES_ROUTES.REPORTS
  const listLink = `/${ROOT}`
  const keyBreadcrumbs = `${keyPrefix}.breadcrumbs`

  const headerItems = [
    { link: listLink, tKey: "navigation.reports" },
    { fieldName: "name_details", tKey: `${keyBreadcrumbs}.create` }
  ]
  const { t } = useTranslation()
  const creator = useCreateReports()
  const updater = usePatchReports()
  const actions = { creator, updater }
  const submitting = creator.isPending || updater.isPending
  const { resource } = props

  return (
    <Form.Page
      id="recurring-report-page"
      resource={resource}
      aside={<Form.Aside items={asideItems} />}
      header={<Form.Header items={headerItems} />}
      footer={
        <Form.Footer
          cancelRedirect={listLink}
          okText={() => t("general.submit")}
          submitting={submitting}
        />
      }
    >
      <RecurringReportForm listLink={listLink} actions={actions} />
    </Form.Page>
  )
}
